import { useState } from "react";

import { isWeb } from "@luce/core";
import { useNavigation } from "@luce/core/adapters/navigation";

import { ADD_PAYMENT_METHOD_PATH } from "../constant";

type UseAddPaymentMethodEntryArgs = {
  screenPath?: string;
  onSuccess?: () => void;
};

export function useAddPaymentMethodEntry({
  screenPath = ADD_PAYMENT_METHOD_PATH,
  onSuccess,
}: UseAddPaymentMethodEntryArgs = {}) {
  const { push } = useNavigation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onSetupCard = () => {
    if (isWeb) {
      setIsModalOpen(true);
      return;
    }
    push(screenPath);
  };

  const onSetupClose = () => setIsModalOpen(false);

  const onSetupSuccess = () => {
    setIsModalOpen(false);
    onSuccess?.();
  };

  return { usesModal: isWeb, isModalOpen, onSetupCard, onSetupClose, onSetupSuccess };
}
